import React, { useEffect, useState,useRef,useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import undoicon from "../assets/icons/icon-undo.svg";
import redoicon from "../assets/icons/icon-redo.svg";
import zoominicon from "../assets/icons/icon-zoomin.svg";
import minusicon from "../assets/icons/icon-minus.svg";
import { setActiveTab } from "../Store/reducers/activeTabSlice";
import { undo, redo } from "../Store/reducers/fabriccontrolsSlice.js";
import { useZoomControls } from "./customHooks/useZoomControls.jsx";
import { clampPivot } from "./customHooks/useZoomControls.jsx";
import { fabricclampViewport

 } from "./customHooks/useZoomControls.jsx";
 
import {
  startPanning,
  movePanning,
  stopPanning,
} from "./pixiComponents/panningUtils.jsx";
import {
  undoAndReload,
  redoAndReload,
} from "../Store/reducers/fabriccontrolsSlice.js";

const Controls = () => {
  const [activeButton, setActiveButton] = useState("previewMockup");
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const zoom = useSelector((state) => state.canvasesstate.zoom);
  const pixiCanvas = useSelector((state) => state.canvas.app);
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const [showTooltip, setShowTooltip] = useState(false);
  const { isCanvasLoaded, isTexturesLoaded } = useSelector(
    (state) => state.wait
  );
  const pixiZoom       = useSelector(s => s.canvas.zoom);
  const isEditMockupDisabled =  ( activeTab === "previewMockup" && !isCanvasLoaded) || activeTab === "editSVG";

  
  const displayZoom   = activeTab === "editSVG" ? zoom : pixiZoom;
  const isSpaceDown = useRef(false);  
  const viewRef = useRef(null);                                         
  const cameraRef = useRef(null);
  

  useEffect(() => {
    console.log("SYNC ZOOM EFFECT:", { activeTab, zoom, hasCanvas: !!fabricCanvas });
    if (activeTab !== "editMockup" || !fabricCanvas) return;
      if (!fabricCanvas.contextContainer) {
    console.warn("fabricCanvas.contextContainer is null, skipping render.");
    return;
  }

    // zoom around canvas center:
    const center = new fabric.Point(
      fabricCanvas.getWidth() / 2,
      fabricCanvas.getHeight() / 2
    );
    fabricCanvas.zoomToPoint(center, pixiZoom);
    fabricclampViewport(fabricCanvas);
    fabricCanvas.renderAll();
  }, [activeTab, pixiZoom, fabricCanvas]);

  
  


  useLayoutEffect(() => {
    if (!pixiCanvas?.view) return;
    const view = pixiCanvas.view;
    const camera = pixiCanvas.cameraContainer;
    viewRef.current = view;
    cameraRef.current = camera;
      view.style.touchAction = "none";
    view.style.userSelect = "none";         
    view.style.willChange = "transform";
  }, [pixiCanvas]);

  useLayoutEffect(() => {
    const onKeyDown = (e) => {
      if (e.code === "Space") {
        e.preventDefault();
        isSpaceDown.current = true; 
      }
    };
    const onKeyUp = (e) => {
      if (e.code === "Space") {
        isSpaceDown.current = false;
        
        
      }
    };
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }, [pixiZoom]);
  

  useEffect(() => {
    setActiveButton(activeTab);
  }, [activeTab]);



  const handleButtonClick = (tab) => {
    setActiveButton(tab);
    dispatch(setActiveTab(tab));
  };

useEffect(() => {
  const onUndoRedo = e => {
    const tag = (e.target.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea") return;

    const ctrl = e.ctrlKey || e.metaKey;         
    const key  = e.key.toLowerCase();

    if (ctrl && key === "z" && !e.shiftKey) {
      dispatch(undoAndReload(`${activeTab}CanvasState`));
    } else if (ctrl && (key === "y" || (key === "z" && e.shiftKey))) {
      dispatch(redoAndReload(`${activeTab}CanvasState`));
    }
  };

  window.addEventListener("keydown", onUndoRedo);
  return () => window.removeEventListener("keydown", onUndoRedo);
}, [dispatch, activeTab]);


  const { zoomIn, zoomOut } = useZoomControls({
    dispatch,
    zoom,
    pixiZoom,
    fabricCanvas,
    activeTab,
    pixiCanvas,
  });


  const handleZoomIn = () => {
    zoomIn();
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 4000);
  };

  useLayoutEffect(() => {
    const view = viewRef.current;
    const camera = cameraRef.current;
    if (!view || activeTab !== "previewMockup") return;
  
    let panningState = {
      isPanning: false,
      startX: 0,
      startY: 0,
      scale: 1,
      startPivotX: 0,
      startPivotY: 0,
    };
  
    const onPointerDown = (e) => {
      if (!isSpaceDown.current || pixiZoom <= 1) return;
      e.preventDefault();
      view.setPointerCapture(e.pointerId);
      view.style.cursor = "grabbing";

      panningState = {
        isPanning: true,
        startX: e.clientX,
        startY: e.clientY,
        scale: camera.scale.x,
        startPivotX: camera.pivot.x,
        startPivotY: camera.pivot.y,
      };
    };
  
    const onPointerMove = (e) => {
      if (!panningState.isPanning) return;
      e.preventDefault();
     view.style.cursor = "grabbing";

      const dx = (e.clientX - panningState.startX) / panningState.scale;
      const dy = (e.clientY - panningState.startY) / panningState.scale;
  
      camera.pivot.x = panningState.startPivotX - dx;
      camera.pivot.y = panningState.startPivotY - dy;
  
      clampPivot(camera, pixiCanvas.screen.width, pixiCanvas.screen.height);
    };
  
    const onPointerUp = (e) => {
      if (panningState.isPanning) {
        panningState.isPanning = false;

          view.style.cursor = "default";
        if (e.pointerId != null) {
          view.releasePointerCapture(e.pointerId);
        }
      }
    };
  
    view.addEventListener("pointerdown", onPointerDown, { passive: false });
    view.addEventListener("pointermove", onPointerMove, { passive: false });
    view.addEventListener("pointerup", onPointerUp);
    view.addEventListener("pointerupoutside", onPointerUp);
  
    return () => {
      view.removeEventListener("pointerdown", onPointerDown);
      view.removeEventListener("pointermove", onPointerMove);
      view.removeEventListener("pointerup", onPointerUp);
      view.removeEventListener("pointerupoutside", onPointerUp);
    };
  }, [activeTab, pixiZoom, pixiCanvas]);
  


  return (
    <div className="flex justify-center items-center mt-[10px] mb-[10px]">
      <div className="flex items-center justify-center gap-[12px]">
        {/* Undo / Redo Controls */}
        <div className="bg-white flex flex-row justify-center items-center rounded space-x-4 mt-4">
          <button
            className="px-2 py-1 hover:bg-gray-200"
            onClick={() => dispatch(undoAndReload(`${activeTab}CanvasState`))}
          >
            <img src={undoicon} alt="undo Icon" className="w-[15px] h-[15px]" />
          </button>
          <button
            className="px-2 py-1 hover:bg-gray-200"
            onClick={() => dispatch(redoAndReload(`${activeTab}CanvasState`))}
          >
            <img src={redoicon} alt="redo Icon" className="w-[15px] h-[15px]" />
          </button>
        </div>

        {/* Zoom Controls */}
        <div className="bg-white flex flex-row justify-center items-center rounded space-x-4 mt-4 mr-40">
          <button className="px-2 text-gray-700" onClick={zoomOut}>
            <img
              src={minusicon}
              alt="minus Icon"
              className="w-[8px] h-[12px]"
            />
          </button>
          <input
            type="text"
            className="w-[42px] h-[15px] font-montserrat leading-[11px] bg-[#ECEBEB] text-center text-[13px] border-none focus:outline-none"
            value={`${(displayZoom * 100).toFixed(0)}%`}
            readOnly
          />
            <div className="relative">
          <button className="text-gray-700 px-2 py-1" onClick={handleZoomIn}>
            <img
              src={zoominicon}
              alt="zoomin Icon"
              className="w-[15px] h-[15px]"
            />
          </button>
          {showTooltip && (
      <div
        className="absolute bottom-full left-1/2 mb-2
                   inline-block px-3 py-1 text-sm font-medium text-white
                   bg-gray-600 rounded-md shadow-xs whitespace-nowrap z-10
                   transform -translate-x-1/2"
      >
        Hold{" "}
        <kbd className="px-2 py-0.5 bg-gray-900 rounded text-[10px]">
          Space
        </kbd>{" "}
        + drag to pan
        {/* arrow centered at bottom */}
        <div
          className="absolute left-1/2 bottom-0
                     w-2 h-2 bg-gray-600 rotate-45
                     transform -translate-x-1/2 translate-y-1/2"
        />
      </div>
    )}
  </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-center space-x-2 mt-4">
          <button
            className={`${
              activeButton === "previewMockup"
                ? "bg-sky-500 text-white"
                : "bg-white text-black"
            } whitespace-nowrap px-2 py-1 font-montserrat text-[12px] font-semibold rounded`}
            onClick={() => handleButtonClick("previewMockup")}
          >
            Preview on Mockup
          </button>
          <button
            className={`${
              activeButton === "editMockup"
                ? "bg-sky-500 text-white"
                : "bg-white text-black"
            } whitespace-nowrap px-2 py-1 font-montserrat text-[12px] font-semibold rounded
  ${isEditMockupDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={() => handleButtonClick("editMockup")}
            disabled={isEditMockupDisabled}
          >
            Style Mockup
          </button>
          <button
            className={`${
              activeButton === "editSVG"
                ? "bg-sky-500 text-white"
                : "bg-white text-black"
            } whitespace-nowrap px-2 py-1 font-montserrat text-[12px] font-semibold rounded`}
            onClick={() => handleButtonClick("editSVG")}
          >
            Edit SVG
          </button>
        </div>
      </div>
    </div>
  );
};

export default Controls;
